import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const MBACoursePage: React.FC = () => {
  const courseData = {
    title: "MBA (Master of Business Administration)",
    shortName: "MBA",
    duration: "2 years",
    description: "Advanced business management program for leadership and strategic decision-making",
    overview: "Master of Business Administration (MBA) is a 2-year postgraduate program that provides comprehensive business knowledge, leadership skills, and strategic thinking capabilities. This course covers various business functions including finance, marketing, operations, human resources, and strategy, preparing students for senior management roles and entrepreneurship.",
    eligibility: [
      "Bachelor's degree from recognized university",
      "Minimum 50% marks in graduation (45% for SC/ST)",
      "Valid CAT/MAT/XAT/GMAT scores",
      "Work experience preferred (2-5 years for executive MBA)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Management Fundamentals",
          "Financial Accounting & Analysis",
          "Marketing Management",
          "Organizational Behavior",
          "Operations Management",
          "Business Statistics"
        ]
      },
      {
        year: 2,
        subjects: [
          "Strategic Management",
          "International Business",
          "Leadership & Change Management",
          "Business Ethics & CSR",
          "Entrepreneurship",
          "Capstone Project"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "General Manager",
        "Business Consultant",
        "Investment Banker",
        "Marketing Manager",
        "Operations Manager",
        "Product Manager",
        "Business Analyst",
        "Strategy Consultant",
        "Entrepreneur",
        "Corporate Development Manager"
      ],
      industries: [
        "Banking & Financial Services",
        "Consulting Firms",
        "Information Technology",
        "Manufacturing Industries",
        "Healthcare & Pharmaceuticals",
        "Retail & E-commerce",
        "Telecommunications",
        "Energy & Infrastructure",
        "Media & Entertainment",
        "Government & Public Sector"
      ],
      averageSalary: "₹8-25 LPA (Fresher), ₹25-80 LPA (Experienced)",
      topRecruiters: [
        "McKinsey, BCG, Bain",
        "Goldman Sachs, JP Morgan",
        "Google, Microsoft, Amazon",
        "TCS, Infosys, Wipro",
        "HDFC, ICICI, SBI",
        "Unilever, P&G, Nestle"
      ]
    },

    admissionProcess: [
      "Entrance exam (CAT/MAT/XAT/GMAT)",
      "Application form submission",
      "Group Discussion and Personal Interview",
      "Academic performance evaluation",
      "Work experience assessment",
      "Final merit list and admission"
    ],

    topColleges: [
      {
        name: "Indian Institute of Management",
        location: "Various Cities",
        fees: "₹20-25 Lakhs",
        ranking: "NIRF Ranking: 1-6"
      },
      {
        name: "Indian School of Business",
        location: "Hyderabad",
        fees: "₹36 Lakhs",
        ranking: "International Recognition"
      },
      {
        name: "SP Jain Institute of Management",
        location: "Mumbai",
        fees: "₹18 Lakhs",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "Great Lakes Institute of Management",
        location: "Chennai",
        fees: "₹16 Lakhs",
        ranking: "NIRF Ranking: 45"
      }
    ],

    skills: [
      "Strategic Thinking",
      "Leadership & Team Management",
      "Financial Analysis",
      "Market Research",
      "Project Management",
      "Communication Skills",
      "Problem Solving",
      "Decision Making",
      "Negotiation Skills",
      "Digital Business Understanding"
    ],

    futureScope: "Excellent growth prospects with digital transformation, startup ecosystem, and global business expansion creating demand for skilled business leaders and managers.",

    faqs: [
      {
        question: "What is the difference between MBA and PGDM?",
        answer: "MBA is a degree program offered by universities, while PGDM is a diploma program offered by autonomous institutes. Both have similar curriculum and career prospects."
      },
      {
        question: "Is work experience mandatory for MBA admission?",
        answer: "Work experience is not mandatory for most MBA programs, but it's preferred and can give an advantage in admissions and placements, especially for executive MBA programs."
      },
      {
        question: "Which MBA specialization has the best job prospects?",
        answer: "Finance, Marketing, and Consulting generally offer high-paying roles. However, emerging areas like Data Analytics, Digital Marketing, and Healthcare Management are also promising."
      },
      {
        question: "Can I pursue MBA through distance learning?",
        answer: "Yes, many universities offer distance/online MBA programs. However, regular full-time MBA programs generally have better placement opportunities and industry recognition."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default MBACoursePage;
